import { request } from '@/utils/ajax';

export function requestOneTimeCode(clientKey: string) {
    return request(`api/signature/${clientKey}/code`, { method: 'POST' });
}